// extracted by mini-css-extract-plugin
export default {"errorPageSubText":"priceFor_errorPageSubText__-RluX","appNavigationButton":"priceFor_appNavigationButton__Ho2dM","priceFor":"priceFor_priceFor__4KEBd"};